interface IGetPercentageAmount {
  base: number;
  percentage: number | null;
  fallback?: number; 
  precision?: number; 
}

function getPercentageAmount({ 
  base, 
  percentage, 
  precision,
  fallback = 0, 
}: IGetPercentageAmount): number {
  if (percentage === null) return fallback;
  
  const value = base * (1 + percentage);
  
  if (typeof precision === 'number') {
    return Number(value.toFixed(precision));
  } 

  return Number(value.toFixed(2));
};

export default getPercentageAmount;
